import client from "libs/HttpClient";

/**
 * Service class for server-migration regeneration tools.
 */
class ServerService {
  /**
   * Rebuild PPTP chap-secrets + OpenVPN auth/ccd/pf files from the DB.
   * Requires the server regen password.
   */
  static regenerateVpn(request: any) {
    return client.post("admin/server/regenerate-vpn", request);
  }

  /**
   * Rebuild the CloudView subdomain blocks inside the nginx site file from
   * the DB. Requires the server regen password.
   */
  static regenerateSubdomains(request: any) {
    return client.post("admin/server/regenerate-subdomains", request);
  }
}

export { ServerService };
